import { Navigate, Route } from 'react-router-dom';

import { ScrollToTopProvider } from 'targets/web/contexts/ScrollToTopProvider';
import { PageNotFoundView } from 'targets/web/modules/dashboard/views';
import { jobsRoutes } from 'targets/customer-portal/modules/jobs/navigation/routes';
import JobsRoutes from 'targets/customer-portal/modules/jobs/navigation/JobsRoutes';
import PortalView from 'targets/customer-portal/modules/portal/views/Dashboard.view';

import ProtectedRoute from './ProtectedRoute';

const DEFAULT_ROUTE = jobsRoutes.jobs;

const AuthorizedRoutes = (
  <Route
    element={
      <ProtectedRoute>
        <ScrollToTopProvider>
          <PortalView />
        </ScrollToTopProvider>
      </ProtectedRoute>
    }
  >
    <Route path="/" element={<Navigate to={DEFAULT_ROUTE} />} />
    <Route path={`${jobsRoutes.jobs}/*`} element={<JobsRoutes />} />
    <Route path="*" element={<PageNotFoundView />} />
  </Route>
);

export default AuthorizedRoutes;
